import { render, staticRenderFns } from "./index_readonly.vue?vue&type=template&id=489ce091&"
import script from "./index_readonly.vue?vue&type=script&lang=js&"
export * from "./index_readonly.vue?vue&type=script&lang=js&"
import style0 from "./index_readonly.vue?vue&type=style&index=0&id=489ce091&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports